import './App.css';
import { useState } from 'react';
import emailjs from 'emailjs-com';


const ProspectingForm = ({data}) => {
  const [fullName, setfullName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [showErrorMesage, setShowErrorMessage] = useState(false);
  const [showSuccessMesage, setShowSuccessMessage] = useState('');
    
  const handleCheckBoxChange = () => {
     setIsChecked(!isChecked);
     setShowErrorMessage(false);
  };
  var templateParams ={
    to_name:'New Prospect',
    from_name:fullName,
    message:`Message : ${message} from : ${email}`,
    reply_to: email,
    phone:phone,
    landingpage:'Front End Developer',
    location:'California',
    type:data? data : 'regular enquiry'
  };

  const axiospost =  (e)=>{
    e.preventDefault();
    if(!isChecked) return  setShowErrorMessage(true);
    emailjs.send('service_0a4jxum','template_5d1ea6d2', templateParams , 'user_zVskoVQi6GgYNK1h7NzD5')
    .then((response) => {
      setShowSuccessMessage(`Message Sent ${response.text}`)
    }, (err) => {
      setShowSuccessMessage('Please try again or Call ')
    });
 
    document.getElementById("create-course-form").reset();
    setMessage("");
  }

  return (
    <div className="formcontainer">
        <div className="formcontainerInstruction">
            <p>Fill the form below &darr;</p>
            {showSuccessMesage ? 
              <p className="successMesssage" onClick={()=>setShowSuccessMessage('')}>{showSuccessMesage}</p>
              :
             <h4 >Our Development Team will contact you</h4>
             }
        </div>
        <form onSubmit={axiospost} id="create-course-form" >
          <div>
            <input 
            required
              className="formcontainerinput" 
              onChange={(e)=>setfullName(e.target.value)}
              type="text" 
              placeholder='Full name*' 
            />
            <input  
              required
              className="formcontainerinput"
              type="email" 
              name='email'
              pattern='[a-zA-Z0-9._+-]+@[a-zA-Z0-9]+\.[a-z]{2,}'
              onChange={(e)=>setEmail(e.target.value)}
              placeholder='Your email*' 
            />
            <div>
            <input
                required
                className="formcontainerinput" 
                type="tel"
                placeholder="tel: 123 456 7890"
                pattern="[0-9]{3} [0-9]{3} [0-9]{4}" 
                maxLength="12"
                title="Ten digits code"
                onChange={(e)=>setPhone(e.target.value)}
             />
            </div>
            <div>
                <textarea 
                    name = "Query"
                    className="formcontainerinput" 
                    type="text"
                    id="CommentsOrAdditionalInformation"
                    value = {message}
                    onChange={e => setMessage(e.target.value)}
                    >
              </textarea>
            </div>
            <div className="formcontainerdiv">
              <input 
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckBoxChange}
              />
              <p>I Agree</p>
            </div>
            {showErrorMesage ?
             <p className="errrorMesage">Pls Check the Agreement box to Submit!!!</p>
              :
              null
            }
            <p className="formcontainerpolicy">
                By checking this box, you are opting-in to receive information, including text messages 
                from Software DevBytes. You also agree to the following <a href="https://www.softwaredevbytes.com/terms">Terms of use</a> 
                , SMS <a href="https://www.softwaredevbytes.com/terms">Terms of  use</a>  
                & <a href="https://www.softwaredevbytes.com/privacy">Privacy Policy</a> . Reply STOP to stop receiving text messages.
            </p>
            <button type='submit' className="formcontainersubmit" >Submit</button>

          </div>

        </form>
    </div>

  )
}

export default ProspectingForm;
